import { ButtonColor } from "@/common/enum/button-color";
import { PaginationSize } from "@/common/enum/pagination-size";
import { Button, Modal, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { TextInputColor } from "../../common/enum/text-input-color";
import { itemService } from "../../services/item-service";
import { BasePageDto } from "../../types/dto/base-page-dto";
import { ErpDataDto } from "../../types/dto/erp-data-dto";
import { CloseOutlineIcon } from "../icon/CloseOutlineIcon";
import { SearchOutlineIcon } from "../icon/SearchOutlineIcon";
import { ItemCodeTable } from "../table/item-code-table/ItemCodeTable";
import { H4 } from "../typography/H4";

interface Props {
  erpCode: string;
  setErpCode: (erpCode: string) => void;
  closeModal: () => void;
}

export const ItemCodeModal: React.FC<Props> = ({
  erpCode,
  setErpCode,
  closeModal,
}) => {
  const [erpPage, setErpPage] = React.useState<BasePageDto<ErpDataDto>>({
    contents: [],
    currentPage: 0,
    totalElements: 0,
    totalPage: 0,
    isFirst: true,
    isLast: false,
  });

  const [keyword, setKeyword] = useState("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  };

  const getPage = async (page: number) => {
    const response = await itemService.getErpPage({
      page: page,
      size: PaginationSize.SIZE_6,
      keyword,
    });
    setErpPage(response.data);
  };

  const handlePageChange = (currentPage: number) => {
    getPage(currentPage);
  };

  useEffect(() => {
    getPage(1);
  }, [keyword]);

  return (
    <Modal size="4xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>상품 코드 검색</H4>
      </Modal.Header>
      <Modal.Body className="overflow-visible min-h-[569px]">
        <div className="flex flex-col gap-[20px]">
          <div className="flex gap-[10px]">
            <TextInput
              required
              value={keyword}
              icon={SearchOutlineIcon}
              placeholder="상품명으로 검색"
              name="oldPassword"
              onChange={handleSearchChange}
              color={TextInputColor.GRAY}
              rightIcon={() => {
                return (
                  <CloseOutlineIcon
                    size={12}
                    onClick={() => {
                      setKeyword("");
                    }}
                  />
                );
              }}
              className="w-[758px] first:pointer-events-auto"
            />
            <Button size={"sm"} color={ButtonColor.PRIMARY}>
              <SearchOutlineIcon color="text-white" />
            </Button>
          </div>
          <ItemCodeTable
            itemPage={erpPage}
            erpCode={erpCode}
            setErpCode={setErpCode}
            handlePageChange={handlePageChange}
            closeModal={closeModal}
          />
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button color={ButtonColor.TRANSPARENT_OUTLINE} onClick={closeModal}>
          닫기
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};
